import { forgetPersistedScenarioIds } from 'store/functions/scenarioIdentity.js';
import { repairPersistedTravelCosts } from 'store/functions/travelCostTyping.js';

/*
Persisted-state migrations, keyed by the version they migrate TO. Wired into
persistConfig in store.js, whose PERSIST_VERSION must have an entry here
(persistGuard.test.js checks). Kept apart from store.js so tests can import the
real steps: store.js calls persistStore and pulls in env-dependent reducers.
*/
export const migrations = {
  // Everything persisted before versioning existed is untrusted; drop it and
  // let the reducers' initial state stand.
  1: () => undefined,
  // 2026-09-17: the open scenario's id moved to one place. Drops the retired
  // top-level generalSettings.scenarioId and forgets the nested id, which may
  // name a different saved scenario (see scenarioIdentity.js for why that is
  // the safe direction). Everything else, including unsaved work, is kept.
  2: (state) => forgetPersistedScenarioIds(state),
  /*
  2026-09-17: travel-cost rows carry the vehicle type's id, not just its name.

  Rows written before 2026-09-15 name their vehicle type and are linked to
  nothing, and rehydrating never went near them — no load path runs on a
  restored blob. So those rows kept a merge key of name, while every row the
  backend returns is keyed by id: `keepExistingTravelCosts` matched nothing and
  "Calculate missing" replaced values people had typed. Links them up, and puts
  the vehicle-type column back in step with the rows. Unsaved work is kept.
  */
  3: (state) => repairPersistedTravelCosts(state),
};
